const brl = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 2,
});

const num = new Intl.NumberFormat('pt-BR');
const pct = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

export const fmt = {
  brl: (n: number) => brl.format(n || 0),
  num: (n: number) => num.format(Math.round(n || 0)),
  pct: (n: number) => `${pct.format(n || 0)}%`,
  ratio: (n: number) => pct.format(n || 0),
};

export function downloadCsv(filename: string, rows: any[], columnIds: string[], headerLabels: Record<string, string>) {
  if (rows.length === 0) return;
  const head = columnIds.map((c) => headerLabels[c] || c).join(',');
  const body = rows
    .map((r) =>
      columnIds
        .map((c) => {
          const v = r[c];
          if (v === undefined || v === null) return '';
          const s = String(v).replace(/"/g, '""');
          return /[",\n]/.test(s) ? `"${s}"` : s;
        })
        .join(',')
    )
    .join('\n');
  const blob = new Blob(['﻿' + head + '\n' + body], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function isoDaysAgo(n: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - n);
  return d.toISOString().slice(0, 10);
}
